import { IStore } from '../../../common/store';

const variantsListSelectors = {
  getVariantsList: (state: IStore) => state.customiseCombinedReducer.variantsListReducer.variantsList,
  getVariantsListLoadingStatus: (state: IStore) => state.customiseCombinedReducer.variantsListReducer.loading,
  getVariantsListError: (state: IStore) => state.customiseCombinedReducer.variantsListReducer.error,
  getVariantListItems: (state: IStore) => state.customiseCombinedReducer.variantsListReducer.variantsList?.items,
  getVariantListModel: (state: IStore) => state.customiseCombinedReducer.variantsListReducer.variantsList?.model,
};

export default variantsListSelectors;
